import { render, staticRenderFns } from "./StoreAttr.vue?vue&type=template&id=359ca050&scoped=true"
import script from "./StoreAttr.vue?vue&type=script&lang=js"
export * from "./StoreAttr.vue?vue&type=script&lang=js"
import style0 from "./StoreAttr.vue?vue&type=style&index=0&id=359ca050&prod&lang=stylus&scoped=true"
import style1 from "./StoreAttr.vue?vue&type=style&index=1&id=359ca050&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ca050",
  null
  
)

export default component.exports